import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import isMobile from "ismobilejs";
import QuestionData from "assets/data/QuestionData";

const browserStyles = theme => {
  return {
    dialogContent: {
      width: 700
    },
    label: {
      padding: "0 15px 3px 7px",
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 20
    },
    itemBtn: {
      margin: 10,
      padding: "8px 15px"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    }
  };
};

const mobileStyles = theme => {
  return {
    dialogTitle: {
      padding: 10
    },
    dialogContent: {
      padding: 10
    },
    label: {
      padding: 2,
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 10,
      display: "grid"
    },
    itemBtn: {
      margin: 5,
      padding: 5,
      fontSize: "1.1rem"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    },
    dialogActions: {
      margin: 0
    }
  };
};

const choiseSentence = (id, locale) => {
  return QuestionData.CHOICES[locale.key].answers.find(
    answer => answer.id === id
  ).name;
};

const BasicButton = props => {
  const { num, selectedNum, locale, classes, handleClick } = props;

  return (
    <Button
      raised
      dense
      onClick={handleClick(num)}
      className={classes.itemBtn}
      classes={{
        raised:
          num === selectedNum
            ? classes.selectedItemBtnRaised
            : classes.itemBtnRaised
      }}
    >
      {choiseSentence(num, locale)}
    </Button>
  );
};

const BasicEditDialog = props => {
  const { classes, basicEditDialog, locale } = props;
  const { open, question, selectedNum } = basicEditDialog;
  const { qNo, text } = question;
  const { handleSelect, handleSubmit, handleClose } = props; // action

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle}>回答の編集</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div>
          <span className={classes.label}>{`${qNo}. ${text}`}</span>
        </div>

        <div className={classes.buttonsDiv}>
          <BasicButton
            num={1}
            selectedNum={selectedNum}
            classes={classes}
            handleClick={handleSelect}
            locale={locale}
          />

          <BasicButton
            num={2}
            selectedNum={selectedNum}
            classes={classes}
            handleClick={handleSelect}
            locale={locale}
          />

          <BasicButton
            num={3}
            selectedNum={selectedNum}
            classes={classes}
            handleClick={handleSelect}
            locale={locale}
          />

          <BasicButton
            num={4}
            selectedNum={selectedNum}
            classes={classes}
            handleClick={handleSelect}
            locale={locale}
          />

          <BasicButton
            num={5}
            selectedNum={selectedNum}
            classes={classes}
            handleClick={handleSelect}
            locale={locale}
          />
        </div>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button raised={!isMobile.any} onClick={handleClose}>
          キャンセル
        </Button>

        <Button
          raised={!isMobile.any}
          onClick={handleSubmit(question, selectedNum)}
        >
          決定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  BasicEditDialog
);



// WEBPACK FOOTER //
// ./src/components/answer/BasicEditDialog.jsx